<template>
    <section class="box pr">
        <div class="pa moon"></div>
        <div v-if="ropeShow" class="pa rope"></div>

        <div v-if="titleShow" class="pa un title-box">
            <div class="title">404</div>
        </div>
        <div v-if="titleShow" class="pa text-box">
            <p class="text">啊叻？你要找的页面不见了？</p>
            <div @click="back" class="bg cp un button">返回上一页</div>
        </div>
    </section>
</template>

<script>
    export default {
        data: () => ({
            titleShow: false,
            ropeShow: false,
        }),
        mounted() {
            setTimeout(() => this.ropeShow = true, 1000);
            setTimeout(() => this.titleShow = true, 2000);
        },
        methods: {
            back() {
                if (window.history.length < 3) return this.$router.push('/');
                this.$router.back();
            }
        }
    }
</script>

<style scoped>
    @import "../../../static/css/components/not-found.css";
</style>


// WEBPACK FOOTER //
// src/components/BaseNotFound/index.vue